import React from 'react';
import childrenArray from '../../utils/childrenArray';
/**
 * ValidChildren component. Only render children of given type.
 *
 * @param props ValidChildren properties.
 */
export const ValidChildren = ({ children, exclude = false, type }) =>
  React.createElement(
    React.Fragment,
    null,
    childrenArray(children, exclude).filter(child => {
      const childType = typeof child === 'string' ? child : child.type;
      const types = Array.isArray(type) ? type : [type];
      return (
        childType === ValidChildren ||
        types[exclude ? 'every' : 'some'](validType =>
          exclude ? childType !== validType : childType === validType
        )
      );
    })
  );
export default ValidChildren;
